import LoginPublic from "@/pages/login-public.vue";
import { Route } from "@soft-db/typed-router";

const loginRoutes = new Route({
	path: "login-public",
	meta: { ignoreAuth: true },
	component: LoginPublic,
});

export default loginRoutes;
